// @ts-nocheck
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import {
    chain,
    LoadRealTimePricing as baseLoadRealTimePricing,
} from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";

export const LoadRealTimePricing = createChainHandler("LoadRealTimePricing", chain, props => {
    if (!props.parameter.unitOfMeasure) {
        return;
    }
    const productOption =
        props.getState().components.productInfoLists.productInfoListById[props.parameter.id]?.productInfoByProductId[
            props.parameter.productId
        ];
    if (props.parameter.unitOfMeasure === productOption?.unitOfMeasure) {
        return;
    }

    const productParameter = {
        productId: props.parameter.productId,
        qtyOrdered: productOption?.qtyOrdered ?? 1,
        unitOfMeasure: props.parameter.unitOfMeasure,
    };

    /* Store Custom Code - Start */
    props.dispatch({
        type: "Store/Data/Products/BeginLoadRealTimePrice",
        productId: props.parameter.productId,
    });
    /* Store Custom Code - End */

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: [productParameter],
            onSuccess: realTimePricing => {
                props.dispatch({
                    type: "Components/ProductInfoLists/CompleteLoadRealTimePricing",
                    id: props.parameter.id,
                    realTimePricing,
                });
                /* Store Custom Code - Start */
                props.dispatch({
                    type: "Store/Data/Products/CompleteLoadRealTimePrice",
                    productId: props.parameter.productId,
                });
                /* Store Custom Code - End */
            },
            onError: () => {
                props.dispatch({
                    type: "Components/ProductInfoLists/FailedLoadRealTimePricing",
                    id: props.parameter.id,
                });
                /* Store Custom Code - Start */
                props.dispatch({
                    type: "Store/Data/Products/CompleteLoadRealTimePrice",
                    productId: props.parameter.productId,
                });
                /* Store Custom Code - End */
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );
});

replaceInChain(chain, baseLoadRealTimePricing, LoadRealTimePricing);
